<script context="module">
  export async function preload(page, session) {
    return {
      productSlug: page.params.productSlug,
    };
  }
</script>

<script>
  import { MetaTags } from "svelte-meta-tags";

  export let productSlug;
</script>

<MetaTags
  title="Design Hub - Step 5. Team Details"
  titleTemplate="%s | Uniform Hero"
  description="Enter your team details. Add each member's name, number, sizing details. Then review and submit your custom uniform order online."
  canonical="https://uniformhero.com.au/design/tasman-sports-tshirt/team-details"
  openGraph={{
    url: `https://uniformhero.com.au/design/${productSlug}/team-details`,
    title: "Uniform Hero | Design Hub Step 1 - Choose Uniform Items",
    description:
      "Order custom uniforms online in 5 easy steps. Fast delivery. Top quality products.",
    images: [
      {
        url: "https://images.uniformhero.com.au/assets/opengraph-banner.jpg",
        width: 1200,
        height: 630,
        alt: "Custom printed uniforms",
      },
    ],
    site_name: "Uniform Hero",
    type: "website",
  }}
/>
